module.exports = __webpack_public_path__ + "static/media/default-placeholder.afd2b479.png";